//Views
import LoginRestrito from "../views/Auth/LoginRestrito";
import LoginMunicipe from "../views/Auth/LoginMunicipe";
import MeuCadastro from "../views/AmbienteMunicipe/MeuCadastro";
import Requerimento from "../views/AmbienteMunicipe/Requerimento";
import Dashboard from "../views/AreaRestrita/Dashboard";
import Requerimentos from "../views/AreaRestrita/Requerimentos/Requerimentos";
import RequerimentosInternos from "../views/AreaRestrita/Requerimentos/RequerimentosInternos";
import MapaDeSupressoes from "../views/AreaRestrita/Mapas/MapaDeSupressoes";
import Regionais from "../views/AreaRestrita/Cadastros/Regionais";
import Documentos from "../views/AreaRestrita/Cadastros/Documentos";
import TiposDeCompensacao from "../views/AreaRestrita/Cadastros/TiposDeCompensacao";
import ModelosDeEmails from "../views/AreaRestrita/Cadastros/ModelosDeEmails";
import Especies from "../views/AreaRestrita/Cadastros/Especies";
import MapeamentoArboreo from "../views/AreaRestrita/Mapas/MapeamentoArboreo";
import Formularios from "../views/AreaRestrita/Cadastros/Formularios";
import TiposDeRequerimentos from "../views/AreaRestrita/Cadastros/TiposDeRequerimentos";
import Cadastro from "../views/Auth/Cadastro";
import Agenda from "../views/AreaRestrita/Agenda";
import Usuarios from "../views/AreaRestrita/Seguranca/Usuarios";
import Perfis from "../views/AreaRestrita/Seguranca/Perfis";
import TrocarSenha from "../views/AreaRestrita/TrocarSenha";
import TrocarSenhaMunicipe from "../views/AmbienteMunicipe/TrocarSenhaMunicipe";
import DownloadAplicativos from "../views/AreaRestrita/DownloadAplicativos";
import ConfirmacaoDePoda from "../views/AreaRestrita/ConfirmacaoDePoda";

//importação dos icones
import {
    faQrcode, faCogs, faFileAlt, faFileImport, faFileInvoice, faFileInvoiceDollar, faFileSignature, faMailBulk, faMap, faMapSigns, faTree, faChartLine, faHome, faCalendar, faCalendarAlt, faLock, faUserAlt, faUserCog, faKey
} from "@fortawesome/free-solid-svg-icons";

var routes = [
    {
        path: "/login",
        name: "Login",
        icon: faChartLine,
        component: LoginMunicipe,
        layout: "/auth",
        sidebar: false,
    },
    {
        path: "/login-restrito",
        name: "ÁREA RESTRITA",
        icon: faChartLine,
        component: LoginRestrito,
        layout: "/auth",
        sidebar: false,
    },
    {
        path: "trocarsenha",
        name: "Trocar Senha",
        icon: faKey,
        component: TrocarSenha,
        layout: "/admin",
        sidebar: false,
        modulo: ["Restrito"]
    },
    {
        path: "/cadastre-se",
        name: "cadastre-se",
        icon: faChartLine,
        component: Cadastro,
        layout: "/auth",
        sidebar: false,
    },
    {
        path: "/meu-cadastro",
        name: "MEU CADASTRO",
        icon: faChartLine,
        component: MeuCadastro,
        layout: "/municipe",
        sidebar: false,
        tipo: "municipe"
    },
    {
        path: "/requerimento",
        name: "REQUERIMENTO",
        icon: faChartLine,
        component: Requerimento,
        layout: "/municipe",
        sidebar: false,
        tipo: "municipe"
    },
    {
        path: "/trocarsenha",
        name: "TROCAR SENHA",
        icon: faKey,
        component: TrocarSenhaMunicipe,
        layout: "/municipe",
        sidebar: false,
        tipo: "municipe",
        logado: true
    },
    {
        codigoFuncionalidade: "Dashboard",
        path: "dashboard",
        name: "Dashboard",
        icon: faHome,
        component: Dashboard,
        layout: "/admin",
        sidebar: true,
        tipo: "restrito",
        modulo: ["Restrito"]
    },
    {
        codigoFuncionalidade: "AgendaFiscalizacoes",
        path: "agenda-de-fiscalizacoes",
        name: "Agenda de fiscalizações",
        icon: faCalendarAlt,
        component: Agenda,
        layout: "/admin",
        sidebar: true,
        tipo: "restrito"
    },
    {
        codigoFuncionalidade: "ConfirmacaoDePoda",
        path: "confirmacao-de-poda",
        name: "Confirmação de poda",
        icon: faTree,
        component: ConfirmacaoDePoda,
        layout: "/admin",
        sidebar: true,
        tipo: "restrito"
    },
    {
        name: "Requerimentos",
        icon: faFileSignature,
        layout: "/admin",
        sidebar: true,
        prefix: "requerimentos",
        submenus: [
            {
                codigoFuncionalidade: "Requerimentos.Consulta",
                descricao: "Consulta",
                path: "requerimentos/lista",
                name: "Consulta",
                icon: faFileSignature,
                layout: "/admin",
                component: Requerimentos,
                sidebar: true,
            },
            {
                codigoFuncionalidade: "Requerimentos.RequerimentoInterno",
                descricao: "Requerimentos internos",
                path: "requerimentos/requerimentos-internos",
                name: "Requerimentos internos",
                icon: faFileSignature,
                layout: "/admin",
                component: RequerimentosInternos,
                sidebar: true,
            }
        ]
    },
    {
        name: "Mapas",
        icon: faMap,
        layout: "/admin",
        sidebar: true,
        prefix: "mapas",
        submenus: [
            {
                codigoFuncionalidade: "Mapas.MapaSupressoes",
                descricao: "Mapa de supressões",
                path: "mapas/mapa-de-supressoes",
                name: "Mapa de supressões",
                icon: faMap,
                layout: "/admin",
                component: MapaDeSupressoes,
                sidebar: true,
            },
            {
                codigoFuncionalidade: "Mapas.MapeamentoArboreo",
                descricao: "Mapa de supressões",
                path: "mapas/mapeamento-arboreo",
                name: "Mapeamento árboreo",
                icon: faMap,
                layout: "/admin",
                component: MapeamentoArboreo,
                sidebar: true,
            },
        ]
    },
    {
        name: "Cadastros",
        icon: faCogs,
        layout: "/admin",
        sidebar: true,
        prefix: "cadastros",
        submenus: [
            {
                codigoFuncionalidade: "Cadastros.Regionais",
                descricao: "Regionais",
                path: "cadastros/regionais",
                name: "Regionais",
                icon: faMapSigns,
                layout: "/admin",
                component: Regionais,
                sidebar: true,
            },
            {
                codigoFuncionalidade: "Cadastros.Documentos",
                descricao: "Documentos",
                path: "cadastros/documentos",
                name: "Documentos",
                icon: faFileAlt,
                layout: "/admin",
                component: Documentos,
                sidebar: true,
            },
            {
                codigoFuncionalidade: "Cadastros.TiposCompensacao",
                descricao: "Tipos de compensação",
                path: "cadastros/tipos-de-compensacao",
                name: "Tipos de compensação",
                icon: faFileInvoiceDollar,
                layout: "/admin",
                component: TiposDeCompensacao,
                sidebar: true,
            },
            {
                codigoFuncionalidade: "Cadastros.ModelosEmail",
                descricao: "Modelos de e-mails",
                path: "cadastros/modelos-de-emails",
                name: "Modelos de e-mails",
                icon: faMailBulk,
                layout: "/admin",
                component: ModelosDeEmails,
                sidebar: true,
            },
            {
                codigoFuncionalidade: "Cadastros.Especies",
                descricao: "Espécies",
                path: "cadastros/especies",
                name: "Espécies",
                icon: faTree,
                layout: "/admin",
                component: Especies,
                sidebar: true,
            },
            {
                codigoFuncionalidade: "Cadastros.Formularios",
                descricao: "Formulários",
                path: "cadastros/formularios",
                name: "Formulários",
                icon: faFileInvoice,
                layout: "/admin",
                component: Formularios,
                sidebar: true,
            },
            {
                codigoFuncionalidade: "Cadastros.TiposRequerimento",
                descricao: "Tipos de requerimentos",
                path: "cadastros/tipos-de-requerimentos",
                name: "Tipos de requerimentos",
                icon: faFileImport,
                layout: "/admin",
                component: TiposDeRequerimentos,
                sidebar: true,
            },
        ]
    },
    {
        name: "Segurança",
        icon: faLock,
        layout: "/admin",
        sidebar: true,
        prefix: "seguranca",
        submenus: [
            {
                codigoFuncionalidade: "Seguranca.Usuarios",
                descricao: "Usuários",
                path: "seguranca/usuarios",
                name: "Usuarios",
                icon: faUserAlt,
                layout: "/admin",
                component: Usuarios,
                sidebar: true,
            },
            {
                codigoFuncionalidade: "Seguranca.Perfis",
                descricao: "Perfis",
                path: "seguranca/perfis",
                name: "Perfis",
                icon: faUserCog,
                layout: "/admin",
                component: Perfis,
                sidebar: true,
            }
        ]
    },
    {
        path: "downloadAplicativos",
        name: "Download do aplicativo",
        icon: faQrcode,
        component: DownloadAplicativos,
        layout: "/admin",
        sidebar: true,
        modulo: ["Restrito"]
    },
];

export default routes;